import {
  Box,
  CircularProgress,
  Paper,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material";
import {
  GridCallbackDetails,
  GridColDef,
  GridRowSelectionModel,
  GridSlotsComponent,
  GridSortModel,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import StyledCustomTableDataGrid from "../../styled-cmps/custom-table-data-grid";

export interface PaginationModel {
  pageSize: number;
  page: number;
}
export interface TableRow {
  [key: string]: any;
}

interface CustomTableProps {
  onSelectRow?: (props: GridRowSelectionModel) => void;
  onSortColumn?: (model: GridSortModel, details: GridCallbackDetails) => void;
  tableRows: TableRow[];
  tableColumns: GridColDef[];
  slots?: Partial<GridSlotsComponent>;
  slotProps?: { [key: string]: any };
  dataGridSx?: SxProps;
  title?: string;
  localeText?: string;
  pageSize?: number;
  extraDataGridSx?: SxProps;
  totalRowNumber?: number;
  page?: number;
  onPaginationModelChange?: (model: PaginationModel) => void;
  isLoading?: boolean;
  checkboxSelection?: boolean;
  onRowClick?: (params: any) => void;
}

const CustomTable = ({
  onSelectRow,
  tableRows,
  checkboxSelection,
  tableColumns,
  isLoading,
  slots,
  slotProps,
  title,
  localeText,
  extraDataGridSx,
  pageSize = 7,
  page = 0,
  totalRowNumber,
  onSortColumn,
  onPaginationModelChange,
  onRowClick,
}: CustomTableProps) => {
  const theme = useTheme();
  const [paginationModel, setPaginationModel] = useState<PaginationModel>({
    page,
    pageSize,
  });

  useEffect(() => {
    setPaginationModel((prevModel) => {
      return { page, pageSize: prevModel.pageSize };
    });
  }, [page]);

  const handlePaginationChange = (model: PaginationModel) => {
    if (onPaginationModelChange) {
      onPaginationModelChange(model);
    }
  };

  return (
    <Box sx={{ position: "relative" }}>
      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", top: "50%", left: "46%" }}
        />
      )}
      <Box
        sx={{
          width: "100%",
          boxShadow: "0px 2px 10px 0px #4C4E6438",

          ...(isLoading && theme.customStyles.disabled),
        }}
      >
        <Box
          sx={{
            background: "white",

            ...theme.customStyles.flexStart,
            paddingInline: "20px",
            height: "86px",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontWeight: "400",
              fontSize: "20px",
            }}
          >
            {title}
          </Typography>
        </Box>
        <Paper
          sx={{
            width: "100%",
            boxShadow: "none",
            borderRadius: "0",
          }}
        >
          <StyledCustomTableDataGrid
            disableColumnMenu
            disableColumnSelector
            localeText={{ noRowsLabel: localeText }}
            onRowSelectionModelChange={(props) =>
              onSelectRow && onSelectRow(props)
            }
            rows={tableRows}
            columns={tableColumns}
            initialState={{
              pagination: { paginationModel: { page: page, pageSize } },
            }}
            paginationMode="server"
            sortingMode="server"
            onSortModelChange={onSortColumn}
            slots={slots}
            rowCount={totalRowNumber}
            slotProps={slotProps}
            checkboxSelection={checkboxSelection}
            onPaginationModelChange={handlePaginationChange}
            disableRowSelectionOnClick
            paginationModel={paginationModel}
            extraDataGridSx={extraDataGridSx}
            onRowClick={onRowClick}
          />
        </Paper>
      </Box>
    </Box>
  );
};

export default CustomTable;
